export default function commaToDot(value) {
    return value.replace(/,/g, '.') 
}